// Espelho das core tools do gateway (apps/gateway/src/mcp/core-tools.ts), na
// ordem do menu. Um domínio novo no gateway precisa entrar aqui também, com a
// descrição em playground.mcpTools.coreTools — o teste do diálogo cobra isso.
export const CORE_TOOL_GROUPS: Array<{ titleKey: string; tools: string[] }> = [
  {
    titleKey: "playground.mcpTools.coreGroups.session",
    tools: ["session_load"],
  },
  {
    // O perfil da pessoa: idioma, instruções pessoais e confirmação de escrita.
    titleKey: "playground.mcpTools.coreGroups.profile",
    tools: ["profile_submit"],
  },
  {
    // O Brain do workspace (AB#86817): a leitura das camadas e a escrita da Mind.
    titleKey: "playground.mcpTools.coreGroups.brain",
    // Os documentos da Knowledge (AB#87121): ler e listar; enviar, substituir e excluir.
    tools: [
      "brain_load",
      "mind_get",
      "knowledge_search",
      "knowledge_get",
      "facets_load",
      "mind_submit",
      "knowledge_submit",
    ],
  },
  {
    // A Memory do Brain (AB#87149): o que pessoas e agentes pediram para lembrar.
    titleKey: "playground.mcpTools.coreGroups.memory",
    tools: ["memory_search", "memory_list", "memory_submit"],
  },
  {
    // Busca na internet (AB#86885).
    titleKey: "playground.mcpTools.coreGroups.utilities",
    tools: ["web_search"],
  },
  {
    // O domínio tools_* do gateway (AB#86575).
    titleKey: "playground.mcpTools.coreGroups.integrations",
    tools: ["tools_load", "tools_get", "tools_run", "tools_store", "tools_submit"],
  },
  {
    // O domínio skills_* do gateway (AB#85630). `skills_run` é a exceção: vive no
    // agentic, não no gateway (AB#85642) — este chat a tem, agentes externos não.
    titleKey: "playground.mcpTools.coreGroups.skills",
    tools: ["skills_load", "skills_get", "skills_resource", "skills_run", "skills_store", "skills_submit"],
  },
  {
    // O domínio jobs_* do gateway (AB#86605): uma Skill num horário ou webhook.
    titleKey: "playground.mcpTools.coreGroups.jobs",
    tools: ["jobs_load", "jobs_get", "jobs_runs", "jobs_submit"],
  },
  {
    // O domínio flows_* do gateway (AB#86605).
    titleKey: "playground.mcpTools.coreGroups.flows",
    tools: ["flows_load", "flows_get", "flows_steps", "flows_submit"],
  },
  {
    titleKey: "playground.mcpTools.coreGroups.admin",
    tools: ["get_mcp_settings", "update_mcp_settings"],
  },
];
